import { Book } from "@/types";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "react-router-dom";
import { useScrollNavigation } from "@/hooks/use-scroll";

interface BookGridProps {
  books: Book[];
}

export function BookGrid({ books }: BookGridProps) {
  const { navigateAndScroll } = useScrollNavigation();

  console.log('Books data:', books);

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {books.map((book) => (
        <div
          key={book.id}
          onClick={() => navigateAndScroll(`/books/${book.slug}`)}
          className="cursor-pointer"
        >
          <Card className="h-full overflow-hidden hover:shadow-lg transition-shadow">
            <div className="aspect-[3/4] relative">
              <img
                src={book.coverUrl}
                alt={book.title}
                className="object-cover w-full h-full transition-transform duration-300 hover:scale-105"
              />
            </div>
            <CardContent className="p-4">
              <h3 className="font-semibold line-clamp-2 mb-1">{book.title}</h3>
              <p className="text-sm text-muted-foreground line-clamp-1">
                {book.description}
              </p>
            </CardContent>
          </Card>
        </div>
      ))}
    </div>
  );
}